<template>
  <div>
    <div class="nav">
      <button v-bind:class="{selected: nav === 0}" v-on:click="nav = 0">Информация по заявке</button>
      <button v-bind:class="{selected: nav === 1}" v-on:click="nav = 1">История</button>
    </div>


    <div v-if="nav === 0" class="border">

      <div class="infoTable">
        <div>
          <ul class="result_table">
            <li class="result_head">
              <p>Номер заявки</p>
              <p>ФИО клиента</p>
              <p>Дата/Время заявки</p>
              <p>Номер телефона клиента</p>
              <p>Адрес регистрации</p>
              <p>Фактический адрес</p>
            </li>
            <li class="result_content">
              <p>{{ demandData.demandID }}</p>
              <p>{{ demandData.clientFIO }}</p>
              <p>{{ $myFilter.timeFromXtoDateView3(demandData.dtDemand) }}</p>
              <p>{{ demandData.clientPhone }}</p>
              <p>{{ demandData.regAddress }}</p>
              <p>{{ demandData.locAddress }}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="callBlock">
        <div class="fl callingBox" id="startCall" v-show="!additionalPhoneFlag">
          <div class="button" v-on:click="startCalling(1)" >Позвонить</div>
          <div style="display: none">{{valueVuex['onlineSimpleWithoutRP']['PHONE']}}</div>
          <div class="button" v-on:click="showAdditionalPhone" >Добавить номер телефона</div>
        </div>
        <div v-show="additionalPhoneFlag" class="fl callingBox">
          <formInput :refs="'PHONE'" :form="'onlineSimpleWithoutRP'"></formInput>
          <div class="button" v-on:click="startCalling(2)" >Позвонить</div>
        </div>
        <div class="fl callingBox">
          <div class="button" v-on:click="sendSms">Отправить СМС</div>
        </div>
      </div>

      <DadataSuggest :refs="'REGISTRATION_ADDRESS'"
                     :form="'onlineSimpleWithoutRP'"
                     v-on:values="checkAddress($event, false)"
      ></DadataSuggest>

      <label class="checkbox">
        <span>Адрес регистрации совпадает с адресом проживания</span>
        <input type="checkbox" v-model="sameAddress"/>
      </label>

      <DadataSuggest :refs="'RESIDENTIAL_ADDRESS'"
                     :form="'onlineSimpleWithoutRP'"
                     v-on:values="checkAddress($event, true)"
      ></DadataSuggest>
      <p class="errorMsg">{{addressData.territoryError}}</p>

      <div class="input_box fl">
        <div class="territory">
          <label  class="left">Территория</label>
          <input readonly v-model="addressData.territory"/>
        </div>
      </div>

<!--      <statusBarReason :statusReasonList="demandData.refCallReason"/>-->

      <statusBarCallStatus
          :callStatusList="demandData.refCallStatus"
          :formTarget="'onlineSimpleWithoutRP'"
      />

    </div>

    <div v-else class="border">
      <div class="infoTable">
        <div>
          <ul class="result_table_history">
            <li class="result_head">
              <p>Тип события</p>
              <p>Комментарий</p>
              <p>Дата события</p>
              <p>Статус события</p>
              <p>ФИО сотрудника</p>
              <p>Перезвонить</p>
            </li>
            <li class="result_content" v-for="(item, index) in demandData.historyEvent" :key="index">
              <p>{{ item.typeEvent }}</p>
              <p>{{ item.comment }}</p>
              <p>{{ $myFilter.timeFromXtoDateView3(item.dtEvent) }}</p>
              <p>{{ item.callStatusName }}</p>
              <p>{{ item.userFIO }}</p>
              <p>{{ $myFilter.timeFromXtoDateView3(item.dtWaitNewCall) }}</p>


<!--              <p>{{ $myFilter.timeFromXtoDateView3(item.datetimeCall) }}</p>-->


            </li>
          </ul>
        </div>
      </div>

    </div>
    <div class="button" v-on:click="saveData">Сохранить</div>







  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import DataForInput from "@/gavnoCode/longFormOptions";
import axios from "axios";

export default {
  name: "detailType2",
  data() {
    return {
      additionalPhoneFlag: false,
      history: [],
      nav: 0,
      demandData: {},
      sameAddress: false,
      addressData: {
        factAddrId: 0,
        territory: '',
        territoryID: 0,
        regAddrId: 0,
        territoryError: ''
      }
    }
  },
  props: {
    DemandID: {
      type: Number,
      default: 0
    },
  },
  components: {
    // statusBarReason: () => import('@/components/status/statusBarReason'),
    statusBarCallStatus: () => import('@/components/status/statusBarCallStatus'),
    DadataSuggest: () => import('@/components/forms/dadataSuggest'),
    DadataSuggestPassport: () => import('@/components/forms/dadataSuggestPassport'),
    formInput: () => import('@/components/forms/formInput')
  },
  methods: {

    clearStore() {
      this.$store.dispatch('resetToDefault');
    },

    startCalling: function () {
      this.$myApi.singleRequest({
        action:'asterisk_startCall_online',
        phone:this.valueVuex['onlineSimpleWithoutRP']['PHONE'],
      }).then((res)=>console.log(res))
          .catch((res)=>console.log(res));
    },
    showAdditionalPhone:function(){
      this.additionalPhoneFlag = true;
    },
    sendSms() {
      this.clearStore();
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_sendSMSSimpleDemand',
        urlType: '',
        method: 'POST',
        UserID: localStorage.getItem('UserID'),
        DemandID: this.DemandID,
      }).then((res) => {
        alert(res);
      }).catch(res => {
        alert(res.Message);
      })
    },

    getData() {
      this.clearStore();
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_getSimpleDemandInfo_withoutRP',
        urlType: '',
        method: 'GET',
        UserID: localStorage.getItem('UserID'),
        DemandID: this.DemandID,
      }).then((res) => {
        this.demandData = res;
        this.$store.dispatch('saveSendData', {
          target: 'PHONE',
          form: 'onlineSimpleWithoutRP',
          value: res.phone
        });
        this.$store.dispatch('saveSendData', {
          target: 'REGISTRATION_ADDRESS',
          form: 'onlineSimpleWithoutRP',
          value: res.regAddress
        });
        this.$store.dispatch('saveSendData', {
          target: 'RESIDENTIAL_ADDRESS',
          form: 'onlineSimpleWithoutRP',
          value: res.locAddress
        });
      }).catch(res => {
        alert(res.Message);
        this.$emit('closeDetails', false);
      })
    },

    checkAddress(value, isFact) {
      console.log('checkAddress');
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/cc_CheckAddress',
        urlType: '',
        method: 'GET',
        UserID: localStorage.getItem('UserID'),
        stringAddress: value.unrestricted_value,
        isFact: isFact,
      }).then((res) => {
        if (isFact) {
          this.addressData.factAddrId = res.addressId;
          this.addressData.territory = res.terrName;
          this.addressData.territoryID = res.terrId;
        } else {
          this.addressData.regAddrId = res.addressId;
        }
        this.addressData.territoryError = ''
      }).catch(res => {
        this.addressData.territoryError = 'Адрес вне территории обслуживания'
        this.addressData.territory = '';
        this.addressData.territoryID = '';
      })
    },

    saveData() {
      if (this.valueVuex.onlineSimpleWithoutRP.callStatus === 0) {
        alert('необходимо установить статус звонка');
        return false;
      }
      if (this.valueVuex.onlineSimpleWithoutRP.subStatusRequired !== 0 && this.valueVuex.onlineSimpleWithoutRP.callSubStatus === 0) {
        alert('необходимо выбрать уточнение к статсу');
        return false;
      }
      let dataToBack = {
        demandID: this.DemandID,
        comment: this.valueVuex.onlineSimpleWithoutRP.OperatorMsg,
        callStatus: this.valueVuex.onlineSimpleWithoutRP.callStatus,
        regAddressID: this.addressData.regAddrId,
        locAddressID: this.addressData.factAddrId,
        terrID: this.addressData.territoryID,
        callSubStatus: this.valueVuex.onlineSimpleWithoutRP.callSubStatus,
      }

      if (this.valueVuex.onlineSimpleWithoutRP.newCallDate.length !== 0 && this.valueVuex.onlineSimpleWithoutRP.newCallTime.length !== 0) {
        dataToBack['dtWaitNewCall'] = this.valueVuex.onlineSimpleWithoutRP.newCallDate + 'T' + this.valueVuex.onlineSimpleWithoutRP.newCallTime;
      }


      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loanNP/CallCenter/CC_setDemandWithoutRP_CallResult',
        urlType: '',
        method: 'POST',
        UserID: localStorage.getItem('UserID'),
        data: dataToBack
      }).then((res) => {
        this.$emit('closeDetails', true);
        alert(res);
      }).catch(res => {
        alert(res.Message);
      })
    },

  },
  computed: {
    ...mapGetters(['getProduct', 'getAvailableSum', 'getAvailablePeriod', 'getSelectedPskInfo']),
    ...mapState({
      valueVuex: state => state.requestField['sendData'],
    }),

    checkBeforeSave() {
      if (this.valueVuex.onlineSimple.callStatus === 6 ) {
        return ''
      }
    }

  },
  watch: {
    sameAddress(value) {
      if (value) {
        this.$store.dispatch('saveSendData', {
          target: 'RESIDENTIAL_ADDRESS',
          form: 'onlineSimpleWithoutRP',
          value: this.valueVuex.onlineSimpleWithoutRP.REGISTRATION_ADDRESS
        });
        this.checkAddress({unrestricted_value: this.valueVuex.onlineSimpleWithoutRP.REGISTRATION_ADDRESS}, false);
        this.checkAddress({unrestricted_value: this.valueVuex.onlineSimpleWithoutRP.RESIDENTIAL_ADDRESS}, true);
      } else {
        this.addressData.factAddrId = '';
        this.addressData.territory = '';
        this.addressData.territoryID = '';
      }
    }
  },
  mounted() {
    this.getData();
  },

}
</script>

<style scoped>
.nav { display: flex }
.nav button { cursor: pointer; padding: 6px 10px; font-size: 16px }
.nav button.selected { background-color: rgb(15, 87, 64); color: white }
.border { border: 1px solid #343434; padding: 20px; position: relative; top: -2px; background-color: white }
.headBlock { width: 50% }

.errorMsg { color: red; text-shadow: 0 0 3px red; display: flex }

.checkbox { display: flex; cursor: pointer; align-items: flex-end; }
.checkbox>input { width: 25px; height: 25px }
.checkbox>span { margin-right: 10px }

.callBlock { display: flex; justify-content: center; }
.callBlock>button { display: flex; align-items: center; }

.border .territory { width: 100% }

.result_table li{display: flex;align-items: stretch;justify-content: start;border:1px solid #c2c2c2;background: rgba(217, 243, 220, 0.52);font-size: 14px;line-height: 1.1; cursor: pointer}
.result_table li:nth-child(2n){background: white;}
.result_table li p{border-left: 1px solid #c2c2c2;padding: 4px;}
.result_table li p:first-child{border-left: 0 solid #c2c2c2;}

.result_table_history li{display: flex;align-items: stretch;justify-content: start;border:1px solid #c2c2c2;background: rgba(217, 243, 220, 0.52);font-size: 14px;line-height: 1.1; cursor: pointer}
.result_table_history li:nth-child(2n){background: white;}
.result_table_history li p{border-left: 1px solid #c2c2c2;padding: 4px;}
.result_table_history li p:first-child{border-left: 0 solid #c2c2c2;}

.result_table p:nth-child(1){width: 10%;}
.result_table p:nth-child(2){width: 10%;}
.result_table p:nth-child(3){width: 10%;}
.result_table p:nth-child(4){width: 10%;}
.result_table p:nth-child(5){width: 30%;}
.result_table p:nth-child(6){width: 30%;}

.result_table>.result_content p:nth-child(2) { font-size: 15px; text-transform: uppercase; font-weight: bold }

.result_table_history p:nth-child(1){width: 16.6%;}
.result_table_history p:nth-child(2){width: 16.6%;}
.result_table_history p:nth-child(3){width: 16.6%;}
.result_table_history p:nth-child(4){width: 16.6%;}
.result_table_history p:nth-child(5){width: 16.6%;}
.result_table_history p:nth-child(6){width: 16.6%;}

.result_table_history>.result_content p:nth-child(5) { font-size: 15px; text-transform: uppercase; font-weight: bold }


</style>
